import { useLocation, Navigate, Outlet } from "react-router-dom";
import SidebarContextProvider, {
  SidebarContext,
} from "../../contexts/SidebarContext";
import PromptTemplateContextProvider from "../../contexts/PromptTemplateContext";
import AssistantContextProvider from "../../contexts/AssistantContext";
import { Footer, Header, MainContent } from "../../component";
import { getUserID, isLoggedIn, sLoggedIn } from "../../Utility/service";
import NewSidebar from "../../component/layout/NewSidebar/NewSidebar";
import WelcomeCard from "../../component/Welcome-Card/WelcomeCard.js";
import { AssistantFetchContextProvider } from "../../contexts/AssistantsFetchContext";
import { FileContextProvider } from "../../contexts/FileContext";
import "./main-layout.scss";
import { useContext } from "react";
import { useEffect, useState } from "react";
import { getAssistantInfo } from "../../api/assistantApiFunctions.js";
import TitleContextProvider from "../../contexts/TitleContext";
import ProfileProvider from "../../contexts/ProfileContext.js";

const Layout = () => {
  const location = useLocation();
  // const { showMenu } = useContext(SidebarContext);
  const [isEmbedded, setIsEmbedded] = useState(false);
  const [isPublic, setIsPublic] = useState(false);
  const [checkUser, setCheckUser] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isOrganizational, setIsOrganizational] = useState(false);
  const userId = getUserID();
  const path = window.location.pathname;
  const regex = /\/agents\/(asst_[^\/]*)/;
  const match = path.match(regex);
  const assistantId = match ? match[1] : null;

  
      useEffect(() => {
          const embeddedParam = new URLSearchParams(window.location.search).get("embedded") === "true";
          setIsEmbedded(embeddedParam);
      }, []);

  useEffect(() => {
    getAssistantInfo(userId, assistantId, (user) => {
      setCheckUser(user);
    }, (publicStatus) => {
      setIsPublic(publicStatus);
    }, (loadingStatus) => {
      setLoading(loadingStatus);
    }, (organizationalStatus) => {
      setIsOrganizational(organizationalStatus);
    });
  }, [userId, assistantId]);

  return loading ? null : (isLoggedIn() || isPublic) ? (
    <AssistantFetchContextProvider>
      <SidebarContextProvider>
        <FileContextProvider>
          <AssistantContextProvider>
            <PromptTemplateContextProvider>
              <ProfileProvider>
                <TitleContextProvider>
                    <main className="d-flex flex-nowrap w-100">
                      <WelcomeCard />
                        {/* <Sidebar /> */}
                        <NewSidebar />
                        <MainContent />
                      </main>
                </TitleContextProvider>
              </ProfileProvider>
            </PromptTemplateContextProvider>
          </AssistantContextProvider>
        </FileContextProvider>
      </SidebarContextProvider>
    </AssistantFetchContextProvider>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default Layout;
